export default function creditCardCvcValidate(value) {
  if (!value) {
    return value
  }

  const onlyNums = value.replace(/[^\d]/g, '')

  return onlyNums.length < 3 ? 'CVC inválido.' : undefined
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/creditCardCvcValidate.js